<template>
    <tr>
        <td class="order-list__column-image">
            <div class="image image--type--product">
                <router-link to="ordered_product.url" class="image__body">
                    <img class="image__tag" :src="ordered_product.image" :alt="ordered_product.product_name">
                </router-link>
            </div>
        </td>
        <td class="order-list__column-product">
            <router-link to="ordered_product.url" v-if="ordered_product.XRITMC != ''">
                {{ordered_product.XRITMC}}
                <span>({{ordered_product.product_name}})</span>
            </router-link>
            <router-link to="ordered_product.url" v-else>
                {{ordered_product.product_name}}
            </router-link>
        </td>
        <td class="order-list__column-quantity" data-title="Quantity:">
            {{ordered_product.quantity}}
        </td>
        <td class="order-list__column-total notranslate" v-if="ordered_product.kit_components == undefined">
            {{toUSD(ordered_product.price * ordered_product.quantity)}}
        </td>
        <td class="order-list__column-total notranslate" v-else>
            {{toUSD(ordered_product.price)}}
        </td>
    </tr>
    <tr v-if="ordered_product.kit_components.length > 0">
        <td></td>
        <td colspan="3">
            <table class="checkout__totals">
                <thead class="checkout__totals-header">
                    <tr>
                        <th>Item</th>
                        <th class="checkout-summary-qty--head"></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody class="checkout__totals-products">
                    <tr v-for="(kc, index) in ordered_product.kit_components" :key="index">
                        <td>
                            {{kc.desc}}<br />
                            <small>Item: {{kc.item}}</small>
                            <small style="margin-left: 10px" v-if="kc.origItem">ALTERNATE for Item: {{kc.origItem}}</small>
                            <small style="margin-left: 10px">MFR: {{kc.manufacturer}}</small>
                        </td>
                        <td class="checkout-summary-qty"><div class="checkout-summary-qty">{{kc.quantity}}</div></td>
                        <td>{{toUSD(kc.linetotal)}}</td>
                    </tr>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script>
import Price from '../../../mixins/price.js';

export default {
    mixins: [
        Price
    ],
    props : {
        ordered_product : {
            type: Object
        }
    },
    mounted() {
        console.log(this.ordered_product);
    }
}
</script>